import AppError_401 from "@/components/ErrorPages/AppError_401";

export default [{
    path:"/401",
    component: AppError_401,
    meta:{
        title:"未授权访问"
    }
}]